import './DownloadInformer.css';

import * as React from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import { IUserDownloadList, DownloadDocumentType } from '../../infrastructure/interfaces';

export interface IDownloadInformerState {
  show: boolean;
}

const mapStateToProps = (state: any): any => {
  return {
    list: state.userDownloadList,
  };
};

@(connect(mapStateToProps, null) as any)
export default class DownloadInformer extends React.Component<any, IDownloadInformerState>{

  constructor(props: any) {
    super(props);
    this.state = {
      show: !!this.props.list.length,
    };
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({
      show: !!nextProps.list.length,
    });
  }
  
  rowStyleForDocumentType = (documentType: DownloadDocumentType): string => {
    switch (documentType) {
      case DownloadDocumentType.PDF:
        return 'download-informer-pdf';
      case DownloadDocumentType.CSV:
        return 'download-informer-csv';
      case DownloadDocumentType.ZIP:
        return 'download-informer-zip';
    }
    return 'download-informer-pdf';
  }

  render() {
    const list = this.props.list;
    const show = this.state.show;

    return show ? createPortal(
      <div className="download-informer">
        <div className="download-informer-head">
          <span className="download-informer-title">Download</span>
          <span className="download-informer-close btn close" onClick={() => this.setState({ show: false })}></span>
        </div>
        <div className="download-informer-body">
          {
            list.map((download: IUserDownloadList, i: any) => (
              <div className="download-informer-row" key={i}>
                <div className="download-informer-name">
                  <span className={'download-informer-row ' + this.rowStyleForDocumentType(download.documentType)}>
                    {download.name}
                  </span>
                </div>
                <span className={`download-informer-spinner status-${download.status}`}></span>
              </div>
            ))
          }
        </div>
      </div>, document.body) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/DownloadInformer/DownloadInformer.tsx